import ArticleCard from 'components/Globals/ArticleCard';
import type { ArticlePreview } from 'interfaces/content/articles/Articles';
import type { RelatedRanking } from 'interfaces/EduRanking';
import type { MediaItem } from 'interfaces/content/Media';
import Link from 'components/Globals/Base/Link';
import { NextCustomImage } from 'components/Image';
import Heading from 'styles/typography/Heading';
import * as S from './EduRelatedStyles';

export type EducationRelatedProps = {
  articles?: ArticlePreview[];
  rankings?: RelatedRanking[];
  title: string;
};

interface RelatedRankingCardProps {
  title: string;
  url: string;
  image?: MediaItem;
}

const RelatedRankingCard = ({ title, url, image }: RelatedRankingCardProps) => (
  <S.RankingCardWrapper>
    {image?.mediaItemUrl && (
      <Link
        href={url}
        type='image'
        className='card-image'
      >
        <NextCustomImage
          width={300}
          height={300}
          src={image.mediaItemUrl}
          alt={image.altText || title}
          className='image-link'
          object-fit='cover'
        />
      </Link>
    )}
    <Heading
      as='h3'
      $fontFamily='saol'
      $size={{ default: 'level6', mdMin: 'level6' }}
      className='card-title'
    >
      <Link
        href={url}
        className='title-link'
        type='primary'
        trackingData={{
          eventCategory: 'navigation',
          eventLabel: `ranking title click : ${title}`,
        }}
      >
        {title}
      </Link>
    </Heading>
  </S.RankingCardWrapper>
);

export const EduRelated = ({ articles, rankings, title }: EducationRelatedProps) => {
  if (articles && !articles.length) {
    return null;
  }
  return (
    <S.Wrapper>
      <S.Title
        $fontFamily='saol'
        $size={{
          default: 'level3',
        }}
      >
        {title}
      </S.Title>
      <S.Container>
        {articles?.map((article) => (
          <ArticleCard
            key={article.titleLink}
            article={article}
            trackingData={{}}
          />
        ))}
        {rankings?.map((ranking) => (
          <RelatedRankingCard
            key={ranking.databaseId}
            title={ranking.title}
            url={ranking.permalink}
            {...(ranking.image && {
              image: {
                altText: ranking.title,
                caption: ranking.title,
                mediaItemUrl: ranking.image,
                src: ranking.image,
              },
            })}
          />
        ))}
      </S.Container>
    </S.Wrapper>
  );
};

export default EduRelated;
